import React from "react";
import Header from "@cdkglobal/epay-admin-component/cjs/components/_onePay/top/header/Header";

import "./_adminPage.css";

const AdminPage = ({ showGoBackLink, history, children, backPage = "/" }) => {
  const goBack = e => {
    e.preventDefault();
    history.push(backPage);
  };

  return (
    <div>
      <div className={"admin-page-global-header"}>
        <Header
          title={"Payments Admin"}
          showStatus={false}
          isStatusSuccess={false}
        />
      </div>
      <div>
        {showGoBackLink && (
          <div className={"admin-page-header-links"}>
            <div className={"admin-page-header-link"}>
              <button 
                type="button"
                onClick={goBack}
                className="back-link-button"
                >
                Back to main page
              </button>
            </div>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default AdminPage;
